module.exports = __webpack_public_path__ + "static/img/logo2.a833389f.png";